import React, { useEffect } from 'react';
import useApp from 'hooks/useApp'
import { Button } from 'components'
import styles from './index.module.css'

const JoinBio = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding center-cont">
				<i className="icon icon_report_intro" />
				<h3 className="intro-tit mt_30">생체 정보가 등록되어 있지 않아요.</h3>
				<span className="intro-sub-tit mt_10">기기에서 생체정보 등록 후 다시 시도해주세요.<br />
					(설정앱 - FaceID 및 암호에서 등록 가능)
				</span>

			</div>
			<div className="flex-shrink_0 padding">
				<div className={styles["join-box"]}>
					<span>모바일 기기의 생체인증에 문제가 없는 경우 소프트웨어 업데이트 후 다시 시도해 보거나, 제조사에 문의해주세요.</span>
				</div>
				<Button className="btn btn--big mt_40">확인</Button>
			</div>
		</div>
	)
}

export default JoinBio